(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = (window.HVTheme && window.HVTheme.root) || '/';
  const cartUrl = (window.HVTheme && window.HVTheme.cart) || '/cart';
  const cartAddUrl = (window.HVTheme && window.HVTheme.cartAdd) || '/cart/add';
  const cartChangeUrl = (window.HVTheme && window.HVTheme.cartChange) || '/cart/change';
  const overlay = $('[data-hv-overlay]');
  function closeAll() {
    $$('.hv-drawer.is-open').forEach(el => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); });
    $$('.hv-modal.is-open').forEach(el => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); });
    overlay?.classList.remove('is-open');
    document.body.classList.remove('hv-locked');
  }
  function openDrawer(id) {
    closeAll();
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-open');
    document.body.classList.add('hv-locked');
    setTimeout(() => el.querySelector('input,button,select,a')?.focus(), 40);
  }
  function openModal(id) {
    closeAll();
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hv-locked');
  }
  document.addEventListener('click', e => {
    const drawerBtn = e.target.closest('[data-open-drawer]');
    if (drawerBtn) { e.preventDefault(); openDrawer(drawerBtn.dataset.openDrawer); return; }
    const modalBtn = e.target.closest('[data-open-modal]');
    if (modalBtn) { e.preventDefault(); openModal(modalBtn.dataset.openModal); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.closest('[data-close-modal]') || e.target === overlay) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  // Header: transparent at the top of the home hero, white after scroll, optional hide-on-scroll.
  const header = $('[data-hv-header]');
  if (header) {
    let lastY = window.scrollY;
    const updateHeader = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 20);
      if (header.dataset.hideOnScroll === 'true' && y > 120) {
        if (y > lastY + 4) header.classList.add('is-hidden');
        else if (y < lastY - 4) header.classList.remove('is-hidden');
      } else header.classList.remove('is-hidden');
      lastY = y;
    };
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }
  async function getCart() {
    const res = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart request failed');
    return res.json();
  }
  async function updateCartCount() {
    try {
      const cart = await getCart();
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (_) {}
  }
  async function refreshCart(open = true, redirectOnError = true) {
    try {
      const res = await fetch(`${root}?section_id=cart-drawer&_=${Date.now()}`);
      if (!res.ok) throw new Error('Section request failed');
      const html = await res.text();
      const box = document.createElement('div');
      box.innerHTML = html;
      const fresh = $('[data-cart-drawer]', box);
      const current = $('[data-cart-drawer]');
      if (!fresh || !current) throw new Error('Cart section missing');
      current.replaceWith(fresh);
      await updateCartCount();
      if (open) openDrawer('CartDrawer');
    } catch (error) {
      if (redirectOnError) window.location.href = cartUrl;
      else throw error;
    }
  }
  // AJAX add to cart.
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-ajax-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn?.querySelector('[data-add-label]');
    const original = label?.textContent || btn?.textContent || 'ADD TO CART';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'ADDING…';
    try {
      const res = await fetch(cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error('Add failed');
      await refreshCart(true);
    } catch (_) {
      form.submit();
    } finally {
      const rootEl = form.closest('[data-product-root]');
      const variantId = Number($('[data-variant-input]', form)?.value || 0);
      const variant = rootEl?._hvVariantData?.variants?.find(v => Number(v.id) === variantId);
      const available = variant ? !!variant.available : true;
      if (btn) btn.disabled = !available;
      if (label) label.textContent = available ? original.replace('ADDING…', 'ADD TO CART') : 'SOLD OUT';
    }
  });
  // Cart quantity/remove.
  document.addEventListener('click', async e => {
    const qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      e.preventDefault();
      const quantity = Math.max(0, Number(qty.dataset.quantity || 0));
      await fetch(cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(qty.dataset.line), quantity }) });
      await refreshCart(false);
      openDrawer('CartDrawer');
      return;
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      await fetch(cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(remove.dataset.line), quantity: 0 }) });
      await refreshCart(false);
      openDrawer('CartDrawer');
    }
  });
  // Shipping protection product (only active if configured in Customize).
  document.addEventListener('change', async e => {
    const protection = e.target.closest('[data-shipping-protection]');
    if (protection) {
      const id = Number(protection.dataset.variantId);
      try {
        if (protection.checked) {
          await fetch(cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1, properties: { _shipping_protection: 'true' } }] }) });
        } else {
          await fetch(cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: 0 }) });
        }
        await refreshCart(false); openDrawer('CartDrawer');
      } catch (_) {}
      return;
    }
    const sort = e.target.closest('[data-sort-select]');
    if (sort) sort.form?.submit();
    const variantSelect = e.target.closest('[data-variant-select]');
    if (variantSelect) {
      const rootEl = variantSelect.closest('[data-product-root]');
      const option = variantSelect.selectedOptions[0];
      setVariant(rootEl, option.value, option.textContent, option.dataset.price, !option.disabled);
    }
  });
  // Apply/remove Shopify discount without leaving the page or closing the cart drawer.
  // Shopify Ajax Cart API: POST cart/update.js with { discount: 'CODE' }.
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();

    const input = $('[data-discount-input]', form);
    const code = (input?.value || '').trim();
    if (!code) return;
    const button = form.querySelector('[type="submit"]');
    if (button?.disabled) return;
    if (button) { button.disabled = true; button.textContent = 'Applying...'; }

    try {
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      });
      if (!response.ok) throw new Error('Discount request failed');
      const cart = await response.json();
      const applications = [
        ...(cart.cart_level_discount_applications || []),
        ...(cart.items || []).flatMap(item =>
          (item.line_level_discount_allocations || [])
            .map(allocation => allocation.discount_application)
            .filter(Boolean)
        )
      ];
      const applied = applications.some(application =>
        application.type === 'discount_code' &&
        String(application.title || application.code || '').trim().toLowerCase() === code.toLowerCase()
      );

      // Renders actual Shopify prices and keeps Cart Drawer open.
      await refreshCart(true, false);
      const updatedForm = $('#CartDrawer [data-discount-form]');
      const message = $('#CartDrawer [data-discount-message]');
      if (!applied && updatedForm) {
        const updatedInput = $('[data-discount-input]', updatedForm);
        if (updatedInput) updatedInput.value = code;
      }
      if (message) {
        message.hidden = false;
        message.textContent = applied
          ? `${code.toUpperCase()} applied.`
          : 'This code is invalid, inactive, or not eligible for your cart.';
        message.style.color = applied ? '#167b46' : '#b42318';
      }
    } catch (error) {
      if (button) { button.disabled = false; button.textContent = 'Apply'; }
      const message = $('#CartDrawer [data-discount-message]') || form.querySelector('[data-discount-message]');
      if (message) {
        message.hidden = false;
        message.textContent = 'Could not check the code. Please try again.';
        message.style.color = '#b42318';
      }
      console.error('Cart discount error:', error);
    }
  });

  document.addEventListener('click', async e => {
    const button = e.target.closest('[data-discount-remove]');
    if (!button) return;
    e.preventDefault();
    if (button.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
      if (!response.ok) throw new Error('Discount removal failed');
      await refreshCart(true, false);
    } catch (error) {
      button.disabled = false;
      const message = $('#CartDrawer [data-discount-message]');
      if (message) {
        message.hidden = false;
        message.textContent = 'Could not remove the code. Please try again.';
        message.style.color = '#b42318';
      }
      console.error('Remove discount error:', error);
    }
  });
  function setVariant(rootEl, id, title, price, available) {
    if (!rootEl) return;
    $$('[data-variant-input]', rootEl).forEach(el => el.value = id);
    $$('[data-variant-btn]', rootEl).forEach(el => el.classList.toggle('is-active', el.dataset.variantId === String(id)));
    $$('[data-product-price]', rootEl).forEach(el => { if (price) el.textContent = price; });
    $$('[data-selected-variant]', rootEl).forEach(el => el.textContent = title || '');
    $$('[data-add-button], [data-buy-now], [data-sticky-add]', rootEl).forEach(el => el.disabled = !available);
    $$('[data-add-label]', rootEl).forEach(el => el.textContent = available ? 'ADD TO CART' : 'SOLD OUT');
    const variant = rootEl._hvVariantData?.variants?.find(v => String(v.id) === String(id));
    if (variant?.color) {
      filterGalleryByColor(rootEl, variant.color);
    }
    if (variant?.featuredMediaId && rootEl._hvVariantReady) focusVariantMedia(rootEl, variant.featuredMediaId);
    const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState({}, '', url);
  }
  function focusVariantMedia(rootEl, mediaId) {
    const slide = rootEl?.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
    if (!slide) return;
    const track = $('[data-gallery-track]', rootEl);
    if (window.matchMedia('(max-width: 900px)').matches && track) {
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      const slides = $$('[data-gallery-slide]', rootEl);
      const index = Math.max(0, slides.indexOf(slide));
      $$('[data-gallery-dot]', rootEl).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    } else {
      const headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hv-header-h-desktop')) || 0;
      window.scrollTo({ top: Math.max(0, slide.getBoundingClientRect().top + window.scrollY - headerH), behavior: 'smooth' });
    }
  }
  function swatchFor(name) {
  const key = String(name || '').trim().toLowerCase();

  const colors = {
    navy: '#172238',
    khaki: '#B7AE99',
    grey: '#929292',
    gray: '#929292',
    brown: '#65483C',
    pink: '#D8A9B3',
    burgundy: '#52232B',
    yellow: '#D5B32A',
    black: '#111111'
  };

  for (const [token, value] of Object.entries(colors)) {
    if (key.includes(token)) return value;
  }

  return '#CFCFCB';
}
function filterGalleryByColor(rootEl, color) {
  if (!rootEl || !color) return;
  const normalizedColor = String(color).trim().toLowerCase();
  const slides = $$('[data-gallery-slide]', rootEl);
  const dots = $$('[data-gallery-dot]', rootEl);
  let visibleSlides = [];
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    const alt = String(img?.getAttribute('alt') || '').toLowerCase();
    const matches = alt.includes(`color:${normalizedColor}`);
    slide.hidden = !matches;
    slide.style.display = matches ? '' : 'none';
    if (matches) {
      visibleSlides.push({
        slide,
        originalIndex: index
      });
    }
  });
  dots.forEach((dot, index) => {
    const visible = visibleSlides.some(item => item.originalIndex === index);
    dot.hidden = !visible;
    dot.style.display = visible ? '' : 'none';
    dot.classList.remove('is-active');
  });
  if (!visibleSlides.length) {
    slides.forEach(slide => {
      slide.hidden = false;
      slide.style.display = '';
    });
    dots.forEach(dot => {
      dot.hidden = false;
      dot.style.display = '';
    });
    return;
  }
  const first = visibleSlides[0];
  const firstDot = dots[first.originalIndex];
  if (firstDot) {
    firstDot.classList.add('is-active');
  }
  const track = $('[data-gallery-track]', rootEl);
  if (track) {
    track.scrollTo({
      left: first.slide.offsetLeft,
      behavior: 'auto'
    });
  }
}
    function initSmartVariantPicker(rootEl) {
    const picker = $('[data-smart-variant-picker]', rootEl);
    const jsonEl = $('[data-smart-variant-data]', rootEl);
    if (!picker || !jsonEl) return;

    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    const variants = (data.variants || []).map(v => ({ ...v, options: v.options || [] }));
    if (!variants.length) return;

    const names = (data.optionNames || []).map(v => String(v || ''));
    const valuesAt = i => [...new Set(variants.map(v => String(v.options?.[i] ?? '').trim()).filter(Boolean))];
    const isLengthValues = vals => vals.length > 0 && vals.every(v => /^(regular|tall)$/i.test(v));
    const standardSizes = ['XXXS','XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL'];
    const canonSize = v => String(v || '').trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');

    const colorIndex = names.findIndex(n => /color|colour|цвет/i.test(n));
    let lengthIndex = names.findIndex(n => /length|inseam|длина|рост/i.test(n));
    let sizeIndex = names.findIndex(n => /size|размер/i.test(n));
    if (sizeIndex >= 0 && !valuesAt(sizeIndex).some(v => standardSizes.includes(v.toUpperCase()))) {
      if (lengthIndex < 0 && isLengthValues(valuesAt(sizeIndex))) lengthIndex = sizeIndex;
      sizeIndex = -1;
    }
    if (lengthIndex < 0 && names.length === 1 && isLengthValues(valuesAt(0))) lengthIndex = 0;

    // Preserve legacy products with one combined option: "Navy / Regular".
    const combined = names.length === 1 && sizeIndex < 0 && lengthIndex < 0 &&
      variants.some(v => String(v.title || '').includes('/'));
    const partsFor = v => {
      if (combined) {
        const parts = String(v.title || '').split('/').map(x => x.trim()).filter(Boolean);
        return {color: parts.length > 1 ? parts.slice(0, -1).join(' / ') : '',
          length: parts[parts.length - 1] || '', size: ''};
      }
      return {
        color: colorIndex >= 0 ? String(v.options?.[colorIndex] ?? '').trim() : '',
        length: lengthIndex >= 0 ? String(v.options?.[lengthIndex] ?? '').trim() : '',
        size: sizeIndex >= 0 ? String(v.options?.[sizeIndex] ?? '').trim() : ''
      };
    };
    variants.forEach(v => Object.assign(v, partsFor(v)));

    let colors = [...new Set(variants.map(v => v.color).filter(Boolean))];
    let lengths = [...new Set(variants.map(v => v.length).filter(Boolean))];
    let sizes = [...new Set(variants.map(v => v.size).filter(Boolean))];
    const selected = variants.find(v => String(v.id) === String(data.selectedVariantId)) ||
      variants.find(v => v.available) || variants[0];
    const state = {
      color: selected.color || colors[0] || '',
      length: selected.length || lengths[0] || '',
      size: selected.size || sizes[0] || ''
    };

    // Preserve old products with unnamed individual variants.
    if (!colors.length && !lengths.length && !sizes.length && variants.length > 1) {
      lengths = variants.map(v => v.title);
      variants.forEach(v => { v.length = v.title; });
      state.length = selected.title;
    }
    rootEl._hvVariantData = {...data, variants};

    const fieldset = (cls, legendText, values, kind) => {
      const fs = document.createElement('fieldset');
      fs.className = cls;
      const legend = document.createElement('legend');
      legend.textContent = legendText;
      if (kind === 'color') {
        const strong = document.createElement('strong');
        strong.dataset.selectedColor = '';
        strong.textContent = state.color;
        legend.append(' — ', strong);
      }
      fs.appendChild(legend);
      const grid = document.createElement('div');
      grid.className = `${cls}__grid`;
      values.forEach(value => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.smartOption = kind;
        btn.dataset.optionValue = value;
        btn.setAttribute('aria-pressed', 'false');
        if (kind === 'color') {
          btn.className = 'hv-color-btn';
          const swatch = document.createElement('span');
          swatch.className = 'hv-color-btn__swatch';
          swatch.style.setProperty('--hv-swatch', swatchFor(value));
          const label = document.createElement('span');
          label.textContent = value;
          btn.append(swatch, label);
        } else {
          btn.className = kind === 'size' ? 'hv-size-btn' : 'hv-length-btn';
          btn.textContent = value;
        }
        grid.appendChild(btn);
      });
      fs.appendChild(grid);
      return fs;
    };

    picker.innerHTML = '';
    // One actual colour needs no choice; keep its value for Shopify variant selection.
    if (colors.length > 1) picker.appendChild(fieldset('hv-color-picker', 'COLOR', colors, 'color'));
    if (lengths.length > 1 || (lengths.length === 1 && !colors.length && !sizes.length)) {
      picker.appendChild(fieldset('hv-length-picker', 'LENGTH', lengths, 'length'));
    }
    if (sizes.length) picker.appendChild(fieldset('hv-size-picker', 'Size', sizes, 'size'));

    const matches = (v, except = '') =>
      (!state.color || except === 'color' || v.color === state.color) &&
      (!state.length || except === 'length' || v.length === state.length) &&
      (!state.size || except === 'size' || v.size === state.size);
    const exactVariant = () => variants.find(v => matches(v));
    const apply = (changedKind = '') => {
      let variant = exactVariant();
      if (changedKind === 'color' && (!variant || !variant.available)) {
        variant = variants.find(v => v.color === state.color && v.available) || variant;
      } else if (changedKind === 'length' && !variant) {
        variant = variants.find(v => v.length === state.length &&
          (!state.color || v.color === state.color) && v.available) || variant;
      } else if (changedKind === 'size' && !variant) {
        variant = variants.find(v => v.size === state.size &&
          (!state.color || v.color === state.color) && v.available) || variant;
      }
      if (!variant) variant = variants.find(v => v.available) || variants[0];
      // Always sync state to the actual selected Shopify variant.
      state.color = variant.color || '';
      state.length = variant.length || '';
      state.size = variant.size || '';

      ['color','length','size'].forEach(kind => {
        $$(`[data-smart-option="${kind}"]`, picker).forEach(btn => {
          const value = btn.dataset.optionValue;
          const active = value === state[kind];
          const canBuy = kind === 'color'
            ? variants.some(v => v.available && v.color === value)
            : variants.some(v => v.available && v[kind] === value && matches(v, kind));
          // Keep selected sold-out choice visible, but prevent selecting nonexistent combinations.
          btn.disabled = !canBuy && !active;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
      const selectedColor = $('[data-selected-color]', picker);
      if (selectedColor) selectedColor.textContent = state.color;
      setVariant(rootEl, variant.id, variant.title, variant.priceText, !!variant.available);
    };

    picker.addEventListener('click', e => {
      const btn = e.target.closest('[data-smart-option]');
      if (!btn || btn.disabled) return;
      const kind = btn.dataset.smartOption;
      if (!Object.prototype.hasOwnProperty.call(state, kind)) return;
      state[kind] = btn.dataset.optionValue;
      apply(kind);
    });
    apply();
    rootEl._hvVariantReady = true;
  }

  document.addEventListener('click', e => {
    const variant = e.target.closest('[data-variant-btn]');
    if (variant && !variant.disabled) {
      const rootEl = variant.closest('[data-product-root]');
      setVariant(rootEl, variant.dataset.variantId, variant.dataset.variantTitle, variant.dataset.price, variant.dataset.available === 'true');
      return;
    }
    
    const dot = e.target.closest('[data-gallery-dot]');
    if (dot) {
      const rootEl = dot.closest('[data-product-root]');
      const track = $('[data-gallery-track]', rootEl);
      const slides = $$('[data-gallery-slide]', rootEl);
      const selectedSlide = slides[Number(dot.dataset.index)];
      const visibleSlides = slides.filter(slide => !slide.hidden);
      const visibleIndex = visibleSlides.indexOf(selectedSlide);

      
if (track && visibleIndex >= 0) {
  track.scrollTo({
    left: track.clientWidth * visibleIndex,
    behavior: 'instant'
  });
}

      return;
    }

    const stickyAdd = e.target.closest('[data-sticky-add]');
    if (stickyAdd) {
      const rootEl = stickyAdd.closest('[data-product-root]');
      const form = $('[data-ajax-product-form]', rootEl);
      form?.requestSubmit();
      return;
    }
    const buyNow = e.target.closest('[data-buy-now]');
    if (buyNow && !buyNow.disabled) {
      const rootEl = buyNow.closest('[data-product-root]');
      const id = Number($('[data-variant-input]', rootEl)?.value);
      if (!id) return;
      buyNow.disabled = true;
      fetch(cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) })
        .then(r => { if (!r.ok) throw new Error(); window.location.href = '/checkout'; })
        .catch(() => { buyNow.disabled = false; });
      return;
    }
    const grid = e.target.closest('[data-grid-mode]');
    if (grid) {
      const collectionRoot = grid.closest('[data-collection-root]');
      const target = $('[data-collection-grid]', collectionRoot);
      const single = grid.dataset.gridMode === 'single';
      target?.classList.toggle('is-single', single);
      $$('[data-grid-mode]', collectionRoot).forEach(btn => btn.classList.toggle('is-active', btn === grid));
      try { localStorage.setItem('hv-grid-mode', single ? 'single' : 'multi'); } catch (_) {}
    }
  });
  // Product gallery dots, smart Color/Length picker and sticky bar.
  $$('[data-product-root]').forEach(rootEl => {
    initSmartVariantPicker(rootEl);
    const track = $('[data-gallery-track]', rootEl);
    
if (track) {

const updateActiveThumb = () => {
  const allSlides = $$('[data-gallery-slide]', rootEl);
  const visibleSlides = allSlides.filter(
    slide => !slide.hidden &&
      getComputedStyle(slide).display !== 'none'
  );

  if (!visibleSlides.length) return;

  const trackRect = track.getBoundingClientRect();
  const center = trackRect.left + trackRect.width / 2;

  let activeSlide = visibleSlides[0];
  let minDistance = Infinity;

  visibleSlides.forEach(slide => {
    const rect = slide.getBoundingClientRect();
    const distance = Math.abs(
      rect.left + rect.width / 2 - center
    );

    if (distance < minDistance) {
      minDistance = distance;
      activeSlide = slide;
    }
  });

  const currentIndex = visibleSlides.indexOf(activeSlide);
  const thumbs = $$('[data-gallery-dot]', rootEl);

  thumbs.forEach(thumb => {
    const slide = allSlides[Number(thumb.dataset.index)];
    const active = slide === activeSlide;

    thumb.classList.toggle('is-active', active);
    thumb.setAttribute('aria-current', String(active));
  });

  // Update photo counter
  const current = $('[data-gallery-photo-current]', rootEl);
  const total = $('[data-gallery-photo-total]', rootEl);

  if (current) {
    current.textContent = String(currentIndex + 1).padStart(2, '0');
  }

  if (total) {
    total.textContent = String(visibleSlides.length).padStart(2, '0');
  }

  // Automatically move thumbnail strip
  const strip = $('.hv-gallery-thumbs', rootEl);
  if (!strip) return;

  const activeThumb = thumbs.find(
    thumb => allSlides[Number(thumb.dataset.index)] === activeSlide
  );

  if (!activeThumb) return;

  const indexKey = String(currentIndex);

  if (strip.dataset.cherryActiveIndex === indexKey) return;
  strip.dataset.cherryActiveIndex = indexKey;

  const items = thumbs.filter(
    thumb => !thumb.hidden &&
      getComputedStyle(thumb).display !== 'none'
  );

  const thumbIndex = items.indexOf(activeThumb);
  if (thumbIndex < 0) return;

  const firstIndex = Math.max(0, thumbIndex - 5);

  const maxScroll = Math.max(
    0, strip.scrollWidth - strip.clientWidth
  );

  const target = Math.min(
    maxScroll,
    Math.max(0, items[firstIndex].offsetLeft - items[0].offsetLeft)
  );

  cancelAnimationFrame(strip._cherryScrollFrame);

  const start = strip.scrollLeft;
  const distance = target - start;

  if (Math.abs(distance) < 1) return;

  strip.classList.add('cherry-auto-scrolling');

  const duration = 180;
  const startTime = performance.now();

  const animate = now => {
    const progress = Math.min(
      (now - startTime) / duration, 1
    );

    const eased = 1 - Math.pow(1 - progress, 3);

    strip.scrollLeft = start + distance * eased;

    if (progress < 1) {
      strip._cherryScrollFrame = requestAnimationFrame(animate);
    } else {
      strip.scrollLeft = target;

      requestAnimationFrame(() => {
        strip.classList.remove('cherry-auto-scrolling');
      });
    }
  };

  strip._cherryScrollFrame = requestAnimationFrame(animate);
};









  track.addEventListener('scroll', updateActiveThumb, {
    passive: true
  });

  const thumbs = $('.hv-gallery-thumbs', rootEl);

  if (thumbs) {
    thumbs.addEventListener('click', e => {
      const clickedThumb = e.target.closest('[data-gallery-dot]');
      if (!clickedThumb) return;

      $$('[data-gallery-dot]', rootEl).forEach(thumb => {
        const isActive = thumb === clickedThumb;

        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    });
  }

}

    const buttons = $('.hv-product__buttons', rootEl);
    const sticky = $('[data-sticky-product]', rootEl);
    if (buttons && sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
      io.observe(buttons);
    }
  });
  // Product recommendations section rendering.
  $$('[data-product-recommendations]').forEach(section => {
    if (!section.dataset.url || section.querySelector('.hv-related__grid:not(.hv-related__grid--loading)')) return;
    fetch(section.dataset.url).then(r => r.text()).then(html => {
      const box = document.createElement('div'); box.innerHTML = html;
      const fresh = $('[data-product-recommendations]', box);
      if (fresh) section.replaceWith(fresh);
    }).catch(() => {});
  });
  // Review slider.
  $$('[data-reviews-carousel]').forEach(section => {
    const track = $('[data-review-track]', section);
    $('[data-review-prev]', section)?.addEventListener('click', () => track?.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    $('[data-review-next]', section)?.addEventListener('click', () => track?.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
  });
  // Restore collection grid preference on mobile/desktop.
  try {
    if (localStorage.getItem('hv-grid-mode') === 'single') {
      $$('[data-collection-root]').forEach(section => {
        $('[data-collection-grid]', section)?.classList.add('is-single');
        $$('[data-grid-mode]', section).forEach(btn => btn.classList.toggle('is-active', btn.dataset.gridMode === 'single'));
      });
    }
  } catch (_) {}
  // Recently viewed products.
  const recentKey = 'hv-recent-products';
  function readRecent() { try { return JSON.parse(localStorage.getItem(recentKey) || '[]'); } catch (_) { return []; } }
  function saveRecent(items) { try { localStorage.setItem(recentKey, JSON.stringify(items.slice(0, 8))); } catch (_) {} }
  const currentJson = $('[data-current-product-json]');
  if (currentJson) {
    try {
      const product = JSON.parse(currentJson.textContent);
      const items = readRecent().filter(item => item.handle !== product.handle);
      items.unshift(product); saveRecent(items);
    } catch (_) {}
  }
  function renderSearchCards(container, items) {
    if (!container) return;
    if (!items.length) { container.innerHTML = '<div class="hv-search-empty">No products yet.</div>'; return; }
    container.innerHTML = items.map(p => `<article class="hv-search-result"><a class="hv-search-result__image" href="${p.url}">${p.image ? `<img src="${p.image}" alt="">` : ''}</a><div class="hv-search-result__meta"><a href="${p.url}">${p.title}</a><strong>${p.price || ''}</strong></div></article>`).join('');
  }
  renderSearchCards($('[data-recently-viewed]'), readRecent().slice(0, 2));
  document.addEventListener('click', e => {
    if (e.target.closest('[data-clear-recent]')) { saveRecent([]); renderSearchCards($('[data-recently-viewed]'), []); }
  });
  let searchTimer;
  document.addEventListener('input', e => {
    const input = e.target.closest('[data-predictive-search-input]');
    if (!input) return;
    clearTimeout(searchTimer);
    const q = input.value.trim();
    const results = $('[data-predictive-results]');
    if (!q) { if (results) results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const data = await fetch(url).then(r => r.json());
        const products = data?.resources?.results?.products || [];
        renderSearchCards(results, products.map(p => ({ title: p.title, url: p.url, image: (typeof p.image === 'string' ? p.image : (p.image?.url || p.featured_image?.url || '')), price: p.price || p.price_min || '' })));
      } catch (_) {}
    }, 180);
  });


  // CHERRY — Sticky bar with manual size selection

  $$('[data-product-root]').forEach(productRoot => {
    const sticky = $('[data-sticky-product]', productRoot);
    const form = $('[data-ajax-product-form]', productRoot);
    const picker = $('[data-smart-variant-picker]', productRoot);

    if (!sticky || !form) return;

    const sizeButtons = () =>
      $$('[data-smart-option="length"]', productRoot);

    const hasSizes = sizeButtons().length > 1;
    const isLength = hasSizes && sizeButtons().every(b =>
      /^(Regular|Tall)$/i.test(b.dataset.optionValue)
    );

    const title = $('.hv-product__panel-inner h1', productRoot)
      ?.textContent.trim() || '';

    const colorName = title.includes('—')
      ? title.split('—').pop().trim()
      : '';

    const getStickyTopLabel = () => {
  const variantId = $('[data-variant-input]', productRoot)?.value;
  const variants = productRoot._hvVariantData?.variants || [];

  const currentVariant = variants.find(
    variant => String(variant.id) === String(variantId)
  );

  return currentVariant?.color || colorName || 'COLOR';
};

const typeLabel = getStickyTopLabel();

    let sizeChosen = !hasSizes;
    let sizeValue = '';

    sticky.classList.add('hv-sticky-product--simple');

    sticky.innerHTML = `
      <button
        type="button"
        class="cherry-sticky__choice"
        data-cherry-open-size
      >
        <small data-cherry-sticky-top>${typeLabel}</small>
        <span data-cherry-size-label>
          ${hasSizes ? 'Choose your size' : 'Ready to order'}
        </span>
        <span class="cherry-sticky__chevron"
          aria-hidden="true">⌄</span>
      </button>

      <button type="button"
        class="cherry-sticky__add"
        data-cherry-sticky-buy>
        ADD TO CART
      </button>
    `;

    const popup = document.createElement('div');
    popup.className = 'cherry-size-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute(
      'aria-label',
      isLength ? 'Choose your length' : 'Choose your size'
    );

    popup.innerHTML = `
      <button type="button"
        class="cherry-size-popup__shade"
        data-cherry-close-size
        aria-label="Close"></button>

      <div class="cherry-size-popup__panel">
        <div class="cherry-size-popup__top">
          <strong>
            ${isLength ? 'CHOOSE YOUR LENGTH' : 'CHOOSE YOUR SIZE'}
          </strong>
          <button type="button"
            data-cherry-close-size
            aria-label="Close">×</button>
        </div>

        <div class="cherry-size-popup__options"
          data-cherry-size-options></div>

        <button type="button"
          class="cherry-size-popup__add"
          data-cherry-popup-add>
          ADD TO CART
        </button>
      </div>
    `;

    productRoot.appendChild(popup);

    const label = $('[data-cherry-size-label]', sticky);
    const stickyAdd = $('[data-cherry-sticky-buy]', sticky);
    const confirmAdd = $('[data-cherry-popup-add]', popup);
    const options = $('[data-cherry-size-options]', popup);

    function updateSizes() {
      const buttons = sizeButtons();
      const selected = buttons.find(b =>
        b.dataset.optionValue === sizeValue
      );

      const allSoldOut = hasSizes &&
        !buttons.some(b => !b.disabled);

      const topLabel = $('[data-cherry-sticky-top]', sticky);

if (topLabel) {
  topLabel.textContent = getStickyTopLabel();
}

label.textContent = !hasSizes
  ? 'Ready to order'
  : sizeChosen
    ? `${isLength ? 'Length' : 'Size'} ${sizeValue}`
    : isLength
      ? 'Choose your length'
      : 'Choose your size';

      stickyAdd.textContent = allSoldOut
        ? 'SOLD OUT' : 'ADD TO CART';

      stickyAdd.disabled = allSoldOut ||
        (sizeChosen && !!selected?.disabled) ||
        (!hasSizes && !!$('[data-add-button]', productRoot)?.disabled);

      confirmAdd.disabled = !sizeChosen || !!selected?.disabled;

      options.innerHTML = '';

      buttons.forEach(source => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cherry-size-popup__option';
        button.textContent = source.dataset.optionValue;
        button.dataset.cherryPickSize = source.dataset.optionValue;
        button.disabled = source.disabled;

        const active = sizeChosen &&
          sizeValue === source.dataset.optionValue;

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));

        options.appendChild(button);
      });
    }

    function openSizes() {
      if (!hasSizes) return;

      updateSizes();
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hv-locked');

      options.querySelector('button:not(:disabled)')?.focus();
    }

    function closeSizes() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hv-locked');
    }

    // Clear visually preselected size.
    if (hasSizes) {
      sizeButtons().forEach(button => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    picker?.addEventListener('click', event => {
  const button = event.target.closest('[data-smart-option]');

  if (!button || button.disabled) return;

  if (button.dataset.smartOption === 'length') {
    sizeChosen = true;
    sizeValue = button.dataset.optionValue;
  }

  requestAnimationFrame(updateSizes);
});

    // Selecting a size in the popup updates the original picker.
    options.addEventListener('click', event => {
      const button = event.target.closest(
        '[data-cherry-pick-size]'
      );

      if (!button || button.disabled) return;

      const original = sizeButtons().find(b =>
        b.dataset.optionValue === button.dataset.cherryPickSize
      );

      original?.click();
    });

    $('[data-cherry-open-size]', sticky)
      .addEventListener('click', openSizes);

    stickyAdd.addEventListener('click', () => {
      if (!sizeChosen) {
        openSizes();
        return;
      }

      form.requestSubmit();
    });

    confirmAdd.addEventListener('click', () => {
      if (!sizeChosen || confirmAdd.disabled) return;

      closeSizes();
      form.requestSubmit();
    });

    popup.addEventListener('click', event => {
      if (event.target.closest('[data-cherry-close-size]')) {
        closeSizes();
      }
    });

    document.addEventListener('keydown', event => {
      if (
        event.key === 'Escape' &&
        popup.classList.contains('is-open')
      ) {
        closeSizes();
      }
    });

    // Block adding the default variant without a size choice.
    form.addEventListener('submit', event => {
      if (hasSizes && !sizeChosen) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openSizes();
      }
    }, true);

    // Apply the same protection to the main Buy Now button.
    $('[data-buy-now]', productRoot)
      ?.addEventListener('click', event => {
        if (hasSizes && !sizeChosen) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openSizes();
        }
      }, true);

    updateSizes();
  });

})();



